import ArrowRightIcon from '@/shared/assets/arrow-right.svg?react';
import { Button } from '@/shared/components/ui/button';

export const NavigationButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button variant={'outline'} btnType="secondary" onClick={onClick}>
      <ArrowRightIcon />
    </Button>
  );
};
